export default __webpack_public_path__ + "static/media/amit.6b2a596e.png";